import { useState } from "react";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";

export default function ContactUs() {
  const [message, setMessage] = useState(false);

  return (
    <div>
      <Navbar />
      <section className="contact_section layout_padding">
        <div className="container">
          <div className="heading_container">
            <h2>
              Contact <span>Us</span>
            </h2>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="form_container contact-form">
                <form
                  onSubmit={(ev) => {
                    ev.preventDefault();
                    setMessage(true);
                  }}
                >
                  <div>
                    <input type="text" placeholder="Your Name" />
                  </div>
                  <div>
                    <input type="text" placeholder="Phone Number" />
                  </div>
                  <div>
                    <input type="email" placeholder="Email" />
                  </div>
                  <div>
                    <input type="text" className="message-box" placeholder="Message" />
                  </div>
                  <div className="btn_box d-flex align-items-center">
                    <button type="submit">SEND</button>
                    {message && <p className="ps-4 mb-0">This feature is not available.</p>}
                  </div>
                </form>
              </div>
            </div>
            <div className="col-md-6">
              <div className="map_container">
                <div className="map">
                  <div id="googleMap"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
